<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="1520px"
            height="900px"
            no-click-animation
            >
            <div :class="{ 'd-none': loading }" >
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-row no-gutters>
                        <v-col cols="3" class="d-flex justify-start align-self-center pt-3 ml-3">{{ golfCourseName }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="3" class="d-flex justify-start align-self-center py-3 ml-3 font-weight-bold">{{ dispYearMonth }}</v-col>
                    </v-row>
                    <v-data-table
                        :headers="headers"
                        :items="dispFeePlanList"
                        hide-default-footer
                        disable-pagination
                        height="600px"
                        class="elevation-1 maxTable"
                    >
                        <template v-slot:item="{ item }">
                            <tr>
                                <td class="text-left">
                                    <div class="pt-1">{{ item.plan_name }}</div>
                                    <div class="d-flex align-center mt-1">
                                        <v-btn
                                            class="mr-1 bulkList"
                                            color="primary"
                                            small
                                            v-for="(check, index) in item.bulkList"
                                            :key="index"
                                            @click="changeBulkList(check.key, index)"
                                        >{{ check.title }}
                                        </v-btn>
                                    </div>
                                </td>
                                <td class="text-left">{{ item.display_total_fee }}</td>
                                <template v-for="(cell, i) in item.days">
                                    <td :key="cell.key" class="text-center">
                                        <input
                                            :id="`input-id-${item.key}-${i}`"
                                            type="checkbox"
                                            v-model="cell.value"
                                            v-if="cell.value !== null"
                                            @click="sendData = false"
                                            :disabled="isCheckedOnSomeDay(item, i)"
                                        >
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                        <v-btn
                            color="green darken-4"
                            text
                            @click="displayAddOverLay"
                            :disabled="sendData || btn[2].isActive">登録</v-btn>
                    </v-card-actions>
                    <AddOverlay
                        page-name="連携枠一覧"
                        @processing="updateFeeIDsToPlanCells"
                        @cancel="closeAddOverLay"
                        :process-result="process"
                        :OverlaySwitch="addOverlay"
                    />
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import AddOverlay from '@/components/overlay/AddOverlay';
// mixins
import { utilityMixin } from '../../../mixins/utility';
// graghql
import { CODE_MASTER } from '@/views/config';
import { GET_FEE_PLAN_LIST, UPDATE_FEE_IDS_TO_PLAN_CELL_BULK } from '@/constants/plan';

export default {
    components: {
        CardTitle,
        AddOverlay
    },
    mixins: [
        utilityMixin
    ],
    props: [
        'dialog',
        'propsAdmin',
        'propsFeePlan',
        'propsYearMonth',
        'golfCourseProps',
        'golfSelectProps'
    ],
    data () {
        return {
            c: 1,
            addOverlay: false,
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            // 検索値
            search: {
                year: '',
                month: ''
            },
            // 入力値
            input: {
                year: '',
                month: '',
                playDateFrom: '',
                playDateTo: '',
                courseValue: '',
                feeValue: ''
            },
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // データテーブルに渡す値
            desserts: [],
            // 送信するデータ
            sendData: true,
            // データテーブルの見出し要素
            headers: [],
            dayOfWeek: [
                { id: Number(CODE_MASTER.SUNDAY['id']), name: CODE_MASTER.SUNDAY['name'] },
                { id: Number(CODE_MASTER.MONDAY['id']), name: CODE_MASTER.MONDAY['name'] },
                { id: Number(CODE_MASTER.TUESDAY['id']), name: CODE_MASTER.TUESDAY['name'] },
                { id: Number(CODE_MASTER.WEDNESDAY['id']), name: CODE_MASTER.WEDNESDAY['name'] },
                { id: Number(CODE_MASTER.THURSDAY['id']), name: CODE_MASTER.THURSDAY['name'] },
                { id: Number(CODE_MASTER.FRIDAY['id']), name: CODE_MASTER.FRIDAY['name'] },
                { id: Number(CODE_MASTER.SATURDAY['id']), name: CODE_MASTER.SATURDAY['name'] }
            ],
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '料金連携',
            // ゴルフ場名
            golfCourseName: '',
            // コースセレクト
            coursesList: [],
            // 料金セレクト
            feeList: [],
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '更新', isActive: true }
            ],
            vue_id: 'SCR0033',
            loading: false,
            dateFromPre: '',
            dateToPre: '',
            targetDays: 0,
            labelObj: {
                'd-flex': true,
                'justify-start': true,
                'align-self-center': true,
                'py-3': true,
                'ml-3': true
            },
            dispYearMonth: '',
            dispFeePlanList: [],
            checkInput: null,
            disabled: false
        };
    },
    async created () {
        this.initialize();
    },
    computed: {
        isCheckedOnSomeDay () {
            return (item, date) => {
                const data = this.dispFeePlanList.map(records => {
                    if (records.plan_id === item.plan_id &&
                        records.fee_id !== item.fee_id) {
                        return records['days'][date]['value'];
                    }
                });
                const filterdData = data.filter(v => v);
                return filterdData[0];
            };
        }
    },
    watch: {
        // 親からデータが渡ってきたときに発火
        propsFeePlan () {
            this.search.year = String(this.propsYearMonth.year);
            this.search.month = String(this.propsYearMonth.month);
            this.dispYearMonth = `${this.search.year}年${this.search.month}月`;
            this.admin = this.propsAdmin;
            this.makeHeaders();
            this.getFeePlanList();
        },
        golfCourseProps () {
            const data = this.golfSelectProps.find(el => el.golf_code === this.golfCourseProps);
            this.golfCourseName = data.golf_name;
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         *---------------------------------------------- */
        initialize: async function () {
            this.input.courseValue = 0;
            this.input.feeValue = 0;
        },
        /** --------------------------------------------
        * ヘッダーを作成
        *-------------------------------------------- */
        makeHeaders () {
            const targetDays = new Date(this.search.year, this.search.month, 0).getDate();
            this.targetDays = targetDays;
            let dayList = [
                { text: 'プラン名', align: 'left', sortable: false, value: 'plan_name', width: 300 },
                { text: '総額', align: 'left', sortable: false, value: 'total_fee', width: 70 }
                // { text: '一括指定', align: 'center', sortable: false, value: '', width: 90 }
            ];
            for (let i = 1; i <= targetDays; i++) {
                let targetDate = new Date(`${this.search.year}-${this.search.month}-${i}`);
                let targetDay = this.dayOfWeek[targetDate.getDay()]['name'];
                if (i < 10) {
                    dayList.push({
                        text: '0' + i + targetDay,
                        align: 'center',
                        sortable: false,
                        value: 'day' + i,
                        class: 'dayWidth' + this.judgeDay(targetDate)
                    });
                } else {
                    dayList.push({
                        text: i + targetDay,
                        align: 'center',
                        sortable: false,
                        value: 'day' + i,
                        class: 'dayWidth' + this.judgeDay(targetDate)
                    });
                }
            }
            this.headers = dayList;
        },
        /** ----------------------------------------
         * 料金情報プラン一覧取得
         * ---------------------------------------- */
        getFeePlanList () {
            this.$store.commit('loading/setIsOpacityLoading', true);
            this.$apollo
                .query({
                    query: GET_FEE_PLAN_LIST,
                    fetchPolicy: 'no-cache',
                    variables: {
                        golf_group_code: this.propsFeePlan.golf_group_code,
                        golf_code: this.propsFeePlan.golf_code,
                        plan_name: this.propsFeePlan.plan_name,
                        plan_member_class: this.propsFeePlan.plan_member_class,
                        share_flag: this.propsFeePlan.share_flag,
                        request_flag: this.propsFeePlan.request_flag,
                        open_flag: this.propsFeePlan.open_flag,
                        search_flag: this.propsFeePlan.search_flag,
                        select_month_start: this.propsFeePlan.select_month_start,
                        user_id: this.admin.user_id,
                        vue_id: this.vue_id,
                        element_id: ''
                    }
                })
                .then(res => {
                    this.dispFeePlanList = JSON.parse(res.data.getFeePlanListFromAdmin.FeePlanList);
                    let opeList = res.data.getFeePlanListFromAdmin.OperationAccessList;
                    for (let list of opeList) {
                        this.btn.forEach(el => {
                            if (list.element_id === el.element_id) {
                                if (list.element_control === 0) {
                                    el.isActive = true;
                                } else {
                                    el.isActive = false;
                                }
                            }
                        });
                    };
                    this.$store.commit('loading/setIsOpacityLoading', false);
                });
        },
        /** --------------------------------------------
        * 一括指定処理
        * @param checkIndex 行番号
        * @param index 選択指定番号(0:全日 1:平日 2:休日)
        *-------------------------------------------- */
        changeBulkList (checkIndex, index) {
            this.dispFeePlanList.forEach((record, i) => {
                Object.keys(record.days).forEach(day => {
                    if (checkIndex === i) {
                        const cell = record.days[day];
                        const current = new Date(`${this.search.year}-${this.search.month}-${cell.day}`);
                        const holiday = this.judgeDay(current);
                        const weekDay = String(current.getDay());
                        this.checkInput = document.getElementById(`input-id-${checkIndex}-${day}`);
                        // 非活性判定
                        if (this.checkInput === null) {
                            this.disabled = true;
                        } else {
                            this.disabled = this.checkInput.disabled;
                        }
                        // 処理対象の行番号が一致した時のみフラグを変更する
                        switch (index) {
                        // 全日指定の場合
                        case 0:
                            // 同じ行かつ活性状態のチェックボックス一括処理
                            if (this.disabled === false) {
                                // 全てチェック
                                cell.value = true;
                            }
                            break;
                        // 平日指定の場合
                        case 1:
                            // 対象行
                            if (this.disabled === false) {
                                // 土日祝日はチェックを外す
                                if (holiday === 0 || weekDay === CODE_MASTER.SUNDAY['id'] || weekDay === CODE_MASTER.SATURDAY['id']) {
                                    cell.value = false;
                                } else {
                                    // 対象行チェック処理
                                    cell.value = true;
                                }
                            }
                            break;
                        // 休日指定の場合
                        case 2:
                            if (this.disabled === false) {
                                // 平日はチェックを外す
                                if (weekDay === CODE_MASTER.SUNDAY['id'] || weekDay === CODE_MASTER.SATURDAY['id'] || holiday === 0) {
                                    cell.value = true;
                                } else {
                                    cell.value = false;
                                }
                            }
                            break;
                        // クリアの場合
                        case 3:
                            if (this.disabled === false) {
                                // 全て外す
                                cell.value = false;
                            }
                            break;
                        }
                    }
                });
            });
            this.sendData = false;
        },
        /** --------------------------------------------
        * 更新処理
        *-------------------------------------------- */
        updateFeeIDsToPlanCells () {
            this.$store.commit('loading/setIsOpacityLoading', true);
            let updateArray = [];
            for (let i = 1; i <= this.targetDays; i++) {
                let checkList = [];
                this.dispFeePlanList.forEach((record) => {
                    Object.keys(record.days).forEach((day) => {
                        if (record.days[day]['day'] === i) {
                            let checkPlanId = record.plan_id;
                            if (checkList.includes(checkPlanId)) {
                                if (Number(record.days[day]['value']) > 0 || record.days[day]['value'] === true) {
                                    const day = this.search.year + '-' + this.search.month.padStart(2, '0') + '-' + String(i).padStart(2, '0');
                                    updateArray.push({
                                        date: day,
                                        fee_id: record.fee_id,
                                        plan_id: record.plan_id,
                                        golf_code: this.golfCourseProps,
                                        golf_group_code: process.env.VUE_APP_GROUP_CODE
                                    });
                                }
                            } else {
                                if (Number(record.days[day]['value']) > 0 || record.days[day]['value'] === true) {
                                    const day = this.search.year + '-' + this.search.month.padStart(2, '0') + '-' + String(i).padStart(2, '0');
                                    updateArray.push({
                                        date: day,
                                        fee_id: record.fee_id,
                                        plan_id: record.plan_id,
                                        golf_code: this.golfCourseProps,
                                        golf_group_code: process.env.VUE_APP_GROUP_CODE
                                    });
                                }

                                // 料金連携の解除は料金未設定時（flag === 0）の時のみにする
                                if ((record.days[day]['value'] === false || record.days[day]['value'] === 0)) {
                                    const day = this.search.year + '-' + this.search.month.padStart(2, '0') + '-' + String(i).padStart(2, '0');
                                    updateArray.push({
                                        date: day,
                                        fee_id: 0,
                                        plan_id: record.plan_id,
                                        golf_code: this.golfCourseProps,
                                        golf_group_code: process.env.VUE_APP_GROUP_CODE
                                    });
                                }
                            }
                            checkList.push(checkPlanId);
                        }
                    });
                });
            }
            this.$apollo.mutate({
                mutation: UPDATE_FEE_IDS_TO_PLAN_CELL_BULK,
                variables: {
                    dateCells: updateArray
                }
            }).then(res => {
                const result = res.data.UpdateFeeIDToPlanCellBulk.result;
                if (result !== 0) {
                    this.process.result = result;
                    this.process.resultText = '更新完了しました';
                    this.sendData = true;
                } else if (result === 0) {
                    throw new Error('更新する情報がありませんでした。');
                }
                this.$store.commit('loading/setIsOpacityLoading', false);
            }).catch(error => {
                this.error = error;
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', '更新する情報がありませんでした。');
                this.$store.commit('loading/setIsOpacityLoading', false);
            });
        },
        /** ----------------------------------------------
         * モーダル画面を表示する処理
         * ---------------------------------------------- */
        displayAddOverLay () {
            this.addOverlay = true;
        },
        /** ----------------------------------------------
         * 追加ダイアログを閉じる
         * ---------------------------------------------- */
        closeAddOverLay (item) {
            this.process.result = '';
            this.addOverlay = false;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.sendData = true;
            this.desserts.splice(0, this.desserts.length);
            this.initialize();
            this.$emit('close');
        }
    }
};
</script>

<style scoped>

    .v-data-table ::v-deep input[type=checkbox] {
        transform:  scale(1.1)
    }

    div.v-input--radio-group__input{
        flex-wrap: nowrap;
    }

    .v-radio ::v-deep label{
        word-break: keep-all;
    }

    .v-data-table ::v-deep th{
        padding: 0 10px;
    }

    .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
        height: 50px;
    }

    .v-data-table ::v-deep td{
        padding: 0 10px;
    }

    .v-data-table ::v-deep .wordKeep{
        word-break: keep-all;
    }

    .v-data-table ::v-deep th.dayWidth0 {
        padding: 11px;
        color: #DD0000 !important;
    }

    .v-data-table ::v-deep th.dayWidth1{
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth2{
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth3{
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth4{
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth5 {
        padding: 11px;
    }

    .v-data-table ::v-deep th.dayWidth6 {
        padding: 11px;
        color: #0000CC !important;
    }
    .bulkList {
        width: 60px;
    }

    .maxTable {
        max-height: 600px;
    }

    .v-data-table >>> .v-data-table__wrapper {
        overflow-y: auto;
        max-height: 600px;
    }

    .v-data-table >>> th {
        background-color: #fff;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        /* tbody内のセルより手前に表示する */
        z-index: 1;
    }
    .v-data-table >>> th:nth-child(1) {
        left: 0;
        z-index: 2;
    }
    .v-data-table >>> td:nth-child(1) {
        position: sticky;
        background-color: #fff;
        left: 0;
        z-index: 1;
    }
    .v-data-table >>> th:nth-child(2) {
        left: 300px;
        z-index: 2;
    }
    .v-data-table >>> td:nth-child(2) {
        position: sticky;
        background-color: #fff;
        left: 300px;
        z-index: 1;
    }
</style>
